var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.05705C23.117 3.44905 22.168 3.71305 21.172 3.83205C22.189 3.22305 22.97 2.25805 23.337 1.10805C22.386 1.67205 21.332 2.08205 20.21 2.30305C19.313 1.34605 18.032 0.748047 16.616 0.748047C13.437 0.748047 11.101 3.71405 11.819 6.79305C7.728 6.58805 4.1 4.62805 1.671 1.64905C0.381 3.86205 1.002 6.75705 3.194 8.22305C2.388 8.19705 1.628 7.97605 0.965 7.60705C0.911 9.88805 2.546 12.022 4.914 12.497C4.221 12.685 3.462 12.729 2.69 12.581C3.316 14.537 5.134 15.96 7.29 16C5.22 17.623 2.612 18.348 0 18.04C2.179 19.437 4.768 20.252 7.548 20.252C16.69 20.252 21.855 12.531 21.543 5.60605C22.505 4.91105 23.34 4.04405 24 3.05705Z",
    fill: "#91A5F8",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c90b5307.svg";
export { ForwardRef as ReactComponent };